import { Column } from "../objects/column";

export const MCI_COLUMN: Column[] = [
    {
        label: 'total-price',
        field_name: 'TOTAL_PRICE',
        checked: true,
        order_by: 'current_version__total_cost',
        fixed_width: true,
        last_updated: false,
        width: null
    }, {
        label: 'remaining-price',
        field_name: 'REMAINING_PRICE',
        checked: true,
        order_by: 'current_version__balance',
        fixed_width: true,
        last_updated: false,
        width: null
    }, {
        label: 'margin',
        field_name: 'MARGIN',
        checked: true,
        order_by: '',
        fixed_width: true,
        last_updated: false,
        width: null
    }, {
        label: 'invoice',
        field_name: 'INVOICE',
        checked: true,
        order_by: '',
        fixed_width: true,
        last_updated: false,
        width: null
    }, {
        label: 'status',
        field_name: 'STATUS',
        checked: true,
        order_by: 'current_version__status',
        fixed_width: false,
        last_updated: false,
        width: null
    }, {
        label: 'folder',
        field_name: 'FOLDER',
        checked: true,
        order_by: 'trip_reference',
        fixed_width: false,
        last_updated: false,
        width: null
    }, {
        label: 'event',
        field_name: 'EVENT',
        checked: true,
        order_by: 'event__localization__name',
        fixed_width: false,
        last_updated: false,
        width: null
    }, {
        label: 'folder-for',
        field_name: 'FOR_USER',
        checked: true,
        order_by: 'current_version__for_user__first_name',
        fixed_width: false,
        last_updated: false,
        width: null
    }, {
        label: 'pax',
        field_name: 'PAX_NUMBER',
        checked: true,
        order_by: '',
        fixed_width: true,
        last_updated: false,
        width: null
    }, {
        label: 'start-date',
        field_name: 'START_DATE',
        checked: true,
        order_by: 'current_version__start_date',
        fixed_width: true,
        last_updated: false,
        width: null
    }, {
        label: 'end-date',
        field_name: 'END_DATE',
        checked: true,
        order_by: 'current_version__end_date',
        fixed_width: true,
        last_updated: false,
        width: null
    }, {
        label: 'agent',
        field_name: 'USER_TO',
        checked: true,
        order_by: 'user_to__username',
        fixed_width: false,
        last_updated: false,
        width: null
    }, {
        label: 'quotation-name',
        field_name: 'QUOTATION_NAME',
        checked: false,
        order_by: 'name',
        fixed_width: false,
        last_updated: false,
        width: null
    }, {
        label: 'created-date',
        field_name: 'CREATED_DATE',
        checked: false,
        order_by: 'created_date',
        fixed_width: true,
        last_updated: false,
        width: null
    }, {
        label: 'created-by',
        field_name: 'CREATED_BY',
        checked: false,
        order_by: 'creator__username',
        fixed_width: true,
        last_updated: false,
        width: null
    }, {
        label: 'modified-date',
        field_name: 'MODIFIED_DATE',
        checked: true,
        order_by: 'modified_date',
        fixed_width: true,
        last_updated: false,
        width: null
    }, {
        label: 'modified-by',
        field_name: 'MODIFIED_BY',
        checked: true,
        order_by: 'last_author__username',
        fixed_width: true,
        last_updated: false,
        width: null
    }];

export const CDV_COLUMN: Column[] = [
    {
        label: 'total-price',
        field_name: 'TOTAL_PRICE',
        checked: true,
        order_by: '',
        fixed_width: true,
        last_updated: false,
        width: null
    }, {
        label: 'remaining-price',
        field_name: 'REMAINING_PRICE',
        checked: true,
        order_by: '',
        fixed_width: true,
        last_updated: false,
        width: null
    }, {
        label: 'margin',
        field_name: 'MARGIN',
        checked: true,
        order_by: '',
        fixed_width: true,
        last_updated: false,
        width: null
    }, {
        label: 'invoice',
        field_name: 'INVOICE',
        checked: true,
        order_by: '',
        fixed_width: true,
        last_updated: false,
        width: null
    }, {
        label: 'status',
        field_name: 'STATUS',
        checked: true,
        order_by: 'current_version__status',
        fixed_width: false,
        last_updated: false,
        width: null
    }, {
        label: 'folder',
        field_name: 'FOLDER',
        checked: true,
        order_by: 'trip_reference',
        fixed_width: false,
        last_updated: false,
        width: null
    }, {
        label: 'lead-traveler',
        field_name: 'LEAD_TRAVELER',
        checked: true,
        order_by: 'current_version__contact_traveler__last_name',
        fixed_width: false,
        last_updated: false,
        width: null
    }, {
        label: 'destination',
        field_name: 'DESTINATION',
        checked: true,
        order_by: 'current_version__destination__current_version__localization__name',
        fixed_width: false,
        last_updated: false,
        width: null
    }, {
        label: 'pax',
        field_name: 'PAX_NUMBER',
        checked: true,
        order_by: '',
        fixed_width: true,
        last_updated: false,
        width: null
    }, {
        label: 'start-date',
        field_name: 'START_DATE',
        checked: true,
        order_by: 'current_version__start_date',
        fixed_width: true,
        last_updated: false,
        width: null
    }, {
        label: 'end-date',
        field_name: 'END_DATE',
        checked: true,
        order_by: 'current_version__end_date',
        fixed_width: true,
        last_updated: false,
        width: null
    }, {
        label: 'bo-agent',
        field_name: 'USER_TO',
        checked: true,
        order_by: 'user_to__username',
        fixed_width: false,
        last_updated: false,
        width: null
    }, {
        label: 'seller',
        field_name: 'USER_TA',
        checked: true,
        order_by: 'user_ta__username',
        fixed_width: false,
        last_updated: false,
        width: null
    }, {
        label: 'quotation-name',
        field_name: 'QUOTATION_NAME',
        checked: false,
        order_by: 'name',
        fixed_width: false,
        last_updated: false,
        width: null
    }, {
        label: 'created-date',
        field_name: 'CREATED_DATE',
        checked: false,
        order_by: 'created_date',
        fixed_width: true,
        last_updated: false,
        width: null
    }, {
        label: 'created-by',
        field_name: 'CREATED_BY',
        checked: false,
        order_by: 'creator__username',
        fixed_width: true,
        last_updated: false,
        width: null
    }, {
        label: 'modified-date',
        field_name: 'MODIFIED_DATE',
        checked: true,
        order_by: 'modified_date',
        fixed_width: true,
        last_updated: false,
        width: null
    }, {
        label: 'modified-by',
        field_name: 'MODIFIED_BY',
        checked: true,
        order_by: 'last_author__username',
        fixed_width: true,
        last_updated: false,
        width: null
    }];

export const MV_COLUMN: Column[] = [
    {
        label: 'total-price',
        field_name: 'TOTAL_PRICE',
        checked: true,
        order_by: '',
        fixed_width: true,
        last_updated: false,
        width: null
    }, {
        label: 'remaining-price',
        field_name: 'REMAINING_PRICE',
        checked: true,
        order_by: '',
        fixed_width: true,
        last_updated: false,
        width: null
    }, {
        label: 'margin',
        field_name: 'MARGIN',
        checked: true,
        order_by: '',
        fixed_width: true,
        last_updated: false,
        width: null
    }, {
        label: 'invoice',
        field_name: 'INVOICE',
        checked: true,
        order_by: '',
        fixed_width: true,
        last_updated: false,
        width: null
    }, {
        label: 'status',
        field_name: 'STATUS',
        checked: true,
        order_by: 'current_version__status',
        fixed_width: false,
        last_updated: false,
        width: null
    }, {
        label: 'folder',
        field_name: 'FOLDER',
        checked: true,
        order_by: 'trip_reference',
        fixed_width: false,
        last_updated: false,
        width: null
    }, {
        label: 'lead-traveler',
        field_name: 'LEAD_TRAVELER',
        checked: true,
        order_by: 'current_version__contact_traveler__last_name',
        fixed_width: false,
        last_updated: false,
        width: null
    }, {
        label: 'destination',
        field_name: 'DESTINATION',
        checked: true,
        order_by: 'current_version__destination__current_version__localization__name',
        fixed_width: false,
        last_updated: false,
        width: null
    }, {
        label: 'pax',
        field_name: 'PAX_NUMBER',
        checked: true,
        order_by: '',
        fixed_width: true,
        last_updated: false,
        width: null
    }, {
        label: 'start-date',
        field_name: 'START_DATE',
        checked: true,
        order_by: 'current_version__start_date',
        fixed_width: true,
        last_updated: false,
        width: null
    }, {
        label: 'end-date',
        field_name: 'END_DATE',
        checked: true,
        order_by: 'current_version__end_date',
        fixed_width: true,
        last_updated: false,
        width: null
    }, {
        label: 'confirmation-date',
        field_name: 'CONFIRMATION_DATE',
        checked: true,
        order_by: 'current_version__confirmation_date',
        fixed_width: true,
        last_updated: false,
        width: null
    }, {
        label: 'quotation-name',
        field_name: 'QUOTATION_NAME',
        checked: false,
        order_by: 'name',
        fixed_width: false,
        last_updated: false,
        width: null
    }, {
        label: 'created-date',
        field_name: 'CREATED_DATE',
        checked: false,
        order_by: 'created_date',
        fixed_width: true,
        last_updated: false,
        width: null
    }, {
        label: 'created-by',
        field_name: 'CREATED_BY',
        checked: false,
        order_by: 'creator__username',
        fixed_width: true,
        last_updated: false,
        width: null
    }, {
        label: 'modified-date',
        field_name: 'MODIFIED_DATE',
        checked: true,
        order_by: 'modified_date',
        fixed_width: true,
        last_updated: false,
        width: null
    }, {
        label: 'modified-by',
        field_name: 'MODIFIED_BY',
        checked: true,
        order_by: 'last_author__username',
        fixed_width: true,
        last_updated: false,
        width: null
    }];

export const BEACHCOMBER_COLUMN: Column[] = [
    {
        label: 'total-price',
        field_name: 'TOTAL_PRICE',
        checked: true,
        order_by: '',
        fixed_width: true,
        last_updated: false,
        width: null
    }, {
        label: 'remaining-price',
        field_name: 'REMAINING_PRICE',
        checked: true,
        order_by: '',
        fixed_width: true,
        last_updated: false,
        width: null
    }, {
        label: 'margin',
        field_name: 'MARGIN',
        checked: true,
        order_by: '',
        fixed_width: true,
        last_updated: false,
        width: null
    }, {
        label: 'invoice',
        field_name: 'INVOICE',
        checked: true,
        order_by: '',
        fixed_width: true,
        last_updated: false,
        width: null
    }, {
        label: 'status',
        field_name: 'STATUS',
        checked: true,
        order_by: 'current_version__status',
        fixed_width: false,
        last_updated: false,
        width: null
    }, {
        label: 'folder',
        field_name: 'FOLDER',
        checked: true,
        order_by: 'trip_reference',
        fixed_width: false,
        last_updated: false,
        width: null
    }, {
        label: 'lead-traveler',
        field_name: 'LEAD_TRAVELER',
        checked: true,
        order_by: 'current_version__contact_traveler__last_name',
        fixed_width: false,
        last_updated: false,
        width: null
    }, {
        label: 'destination',
        field_name: 'DESTINATION',
        checked: true,
        order_by: 'current_version__destination__current_version__localization__name',
        fixed_width: false,
        last_updated: false,
        width: null
    }, {
        label: 'pax',
        field_name: 'PAX_NUMBER',
        checked: true,
        order_by: '',
        fixed_width: true,
        last_updated: false,
        width: null
    }, {
        label: 'start-date',
        field_name: 'START_DATE',
        checked: true,
        order_by: 'current_version__start_date',
        fixed_width: true,
        last_updated: false,
        width: null
    }, {
        label: 'end-date',
        field_name: 'END_DATE',
        checked: true,
        order_by: 'current_version__end_date',
        fixed_width: true,
        last_updated: false,
        width: null
    }, {
        label: 'to-agent',
        field_name: 'USER_TO',
        checked: true,
        order_by: 'user_to__username',
        fixed_width: false,
        last_updated: false,
        width: null
    }, {
        label: 'agency-agent',
        field_name: 'USER_TA',
        checked: true,
        order_by: 'user_ta__username',
        fixed_width: false,
        last_updated: false,
        width: null
    }, {
        label: 'quotation-name',
        field_name: 'QUOTATION_NAME',
        checked: false,
        order_by: 'name',
        fixed_width: false,
        last_updated: false,
        width: null
    }, {
        label: 'to-agency',
        field_name: 'TO_AGENCY',
        checked: false,
        order_by: '',
        fixed_width: false,
        last_updated: false,
        width: null
    }, {
        label: 'visible-to-agency',
        field_name: 'VISIBILITY',
        checked: false,
        order_by: '',
        fixed_width: false,
        last_updated: false,
        width: null
    }, {
        label: 'created-date',
        field_name: 'CREATED_DATE',
        checked: false,
        order_by: 'created_date',
        fixed_width: true,
        last_updated: false,
        width: null
    }, {
        label: 'created-by',
        field_name: 'CREATED_BY',
        checked: false,
        order_by: 'creator__username',
        fixed_width: true,
        last_updated: false,
        width: null
    }, {
        label: 'modified-date',
        field_name: 'MODIFIED_DATE',
        checked: true,
        order_by: 'modified_date',
        fixed_width: true,
        last_updated: false,
        width: null
    }, {
        label: 'modified-by',
        field_name: 'MODIFIED_BY',
        checked: true,
        order_by: 'last_author__username',
        fixed_width: true,
        last_updated: false,
        width: null
    }];

export const DEFAULT_COLUMN: Column[] = [
    {
        label: 'invoice',
        field_name: 'INVOICE',
        checked: true,
        order_by: '',
        fixed_width: true,
        last_updated: false,
        width: null
    },
    {
        label: 'total-price',
        field_name: 'TOTAL_PRICE',
        checked: true,
        order_by: '',
        fixed_width: true,
        last_updated: false,
        width: null
    }, {
        label: 'remaining-price',
        field_name: 'REMAINING_PRICE',
        checked: true,
        order_by: '',
        fixed_width: true,
        last_updated: false,
        width: null
    }, {
        label: 'margin',
        field_name: 'MARGIN',
        checked: true,
        order_by: '',
        fixed_width: true,
        last_updated: false,
        width: null
    }, {
        label: 'status',
        field_name: 'STATUS',
        checked: true,
        order_by: 'current_version__status',
        fixed_width: false,
        last_updated: false,
        width: null
    }, {
        label: 'folder',
        field_name: 'FOLDER',
        checked: true,
        order_by: 'trip_reference',
        fixed_width: false,
        last_updated: false,
        width: null
    }, {
        label: 'lead-traveler',
        field_name: 'LEAD_TRAVELER',
        checked: true,
        order_by: 'current_version__contact_traveler__last_name',
        fixed_width: false,
        last_updated: false,
        width: null
    }, {
        label: 'destination',
        field_name: 'DESTINATION',
        checked: true,
        order_by: 'current_version__destination__current_version__localization__name',
        fixed_width: false,
        last_updated: false,
        width: null
    }, {
        label: 'pax',
        field_name: 'PAX_NUMBER',
        checked: true,
        order_by: '',
        fixed_width: true,
        last_updated: false,
        width: null
    }, {
        label: 'start-date',
        field_name: 'START_DATE',
        checked: true,
        order_by: 'current_version__start_date',
        fixed_width: true,
        last_updated: false,
        width: null
    }, {
        label: 'end-date',
        field_name: 'END_DATE',
        checked: true,
        order_by: 'current_version__end_date',
        fixed_width: true,
        last_updated: false,
        width: null
    }, {
        label: 'to-agent',
        field_name: 'USER_TO',
        checked: true,
        order_by: 'user_to__username',
        fixed_width: false,
        last_updated: false,
        width: null
    }, {
        label: 'agency-agent',
        field_name: 'USER_TA',
        checked: true,
        order_by: 'user_ta__username',
        fixed_width: false,
        last_updated: false,
        width: null
    }, {
        label: 'quotation-name',
        field_name: 'QUOTATION_NAME',
        checked: false,
        order_by: 'name',
        fixed_width: false,
        last_updated: false,
        width: null
    }, {
        label: 'to-agency',
        field_name: 'TO_AGENCY',
        checked: false,
        order_by: '',
        fixed_width: false,
        last_updated: false,
        width: null
    }, {
        label: 'created-date',
        field_name: 'CREATED_DATE',
        checked: false,
        order_by: 'created_date',
        fixed_width: true,
        last_updated: false,
        width: null
    }, {
        label: 'created-by',
        field_name: 'CREATED_BY',
        checked: false,
        order_by: 'creator__username',
        fixed_width: true,
        last_updated: false,
        width: null
    }, {
        label: 'modified-date',
        field_name: 'MODIFIED_DATE',
        checked: true,
        order_by: 'modified_date',
        fixed_width: true,
        last_updated: false,
        width: null
    }, {
        label: 'modified-by',
        field_name: 'MODIFIED_BY',
        checked: true,
        order_by: 'last_author__username',
        fixed_width: true,
        last_updated: false,
        width: null
    }];